import { Controller } from "@hotwired/stimulus"
import openModal from "../utils/remote-modal";

export default class extends Controller {
  static targets = ['loaderContainer']
  static values = { customEvent: String }

  connect() {
    if (this.shouldOpenModal()) {
      this.openModal();
    }
    this.injectedComponents = [];

    document.addEventListener(
      "turbolinks:before-cache",
      () => {
        this.teardown();
      },
      { once: true }
    );

    this.isInProgress = false;
  }

  shouldOpenModal() {
    return window.location.search.includes('modal_id')
  }

  openModal() {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    const localeIndex = pathSegments.indexOf('landlord') + 1;
    const locale = pathSegments[localeIndex]
    const params = new URLSearchParams(window.location.search)
    const modal_id = params.get("modal_id")
    const url = `/landlord/${locale}/cart_offers/${modal_id}/edit?bulk=true&view_only=true`
    const el = document.getElementById("open_modal_trigger")

    el.setAttribute("data-remote-modal-url", url)
    el.click()

    setTimeout(function() {
      window.history.replaceState(null, '', (url => (url.searchParams.delete('modal_id'), url.href))(new URL(window.location.href)));
    },0);
  }

  inject(event) {
    const url = this.data.get('url');
    let originalText;
    let intervalId;

    if (this.isInProgress) return
    this.isInProgress = true

    if (this.hasLoaderContainerTarget) {
      let dotCount = 1;
      const loadingText = 'Loading';
      originalText = this.loaderContainerTarget.innerText

      intervalId = setInterval(() => {
        this.loaderContainerTarget.innerText = loadingText + '.'.repeat(dotCount);
        dotCount = dotCount % 3 + 1;
      }, 500);
    }

    openModal(url, (id) => {
      this.injectedComponents.push(id);
      this.isInProgress = false

      if (this.hasLoaderContainerTarget) {
        clearInterval(intervalId);
        this.loaderContainerTarget.innerText = originalText
      }

      if (this.hasCustomEventValue) {
        document.dispatchEvent(new CustomEvent(this.customEventValue))
      }
    })
  }

  teardown() {
    this.injectedComponents.forEach(id => $('#' + id).remove())
  }
}
